import React from "react";
import "./Electrical.css";
import electricalImage from "../Assets/consultancy.png"; // Ensure correct path to your image

const Electrical = () => {
    return (
        <section className="electrical">
            <div className="content">
                <div className="text">
                    <h3>Electrical Installation & Protection Consultancy</h3>
                    <p>
                        Our expert consultancy services provide tailored solutions for electrical systems. 
                        Whether it's a new installation, maintenance, or protection planning, we ensure 
                        your systems are safe, efficient, and built to last.
                    </p>
                    <p>
                        With years of industry experience, we guide you through the best practices, regulations,
                        and cutting-edge technologies to ensure your electrical infrastructure meets the highest standards.
                    </p>
                </div>
                <div className="image">
                    <img src={electricalImage} alt="Electrical Systems" />
                </div>
            </div>
        </section>
    );
};

export default Electrical;
